export default __webpack_public_path__ + "static/media/home-page-photo.51184488.jpg";